import * as React from "react";
import { useAccount, State } from "@grandvisionhq/auth";
import { Context } from "@grandvisionhq/carts-v2";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useFetchUserDetails } from "../../../../hooks/user/hooks/user/use-fetch-user-details.js";
import { useAuthToken } from "../../../../hooks/user/hooks/user/useAuthToken.js";
import { useCheckoutSettings } from "../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const useUserStateConfig = () => {
  const { loadUserDetails, loading: isLoadingUserData, userData, error } = useFetchUserDetails();
  const { cart } = Context.useCart();
  const { shippingFormFields } = useCheckoutSettings();
  const prepareInitialFormValues = (formFields) => formFields.reduce((field, currField) => ({ ...field, [currField]: "" }), {});
  const invoiceDetails = shippingFormFields?.invoice && shippingFormFields?.invoice.length ? prepareInitialFormValues(shippingFormFields?.invoice) : void 0;
  const companyDetails = shippingFormFields?.company && shippingFormFields?.company.length ? prepareInitialFormValues(shippingFormFields.company) : void 0;
  const { isMyAccountEnabled } = useFeatureToggles();
  const authState = useAccount();
  const [, authTokenState] = useAuthToken();
  const authToken = authTokenState.data;
  const isLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn && Boolean(authToken);
  const formatFormFields = React.useCallback(
    (formData, formName) => Object.entries(formData).reduce((item, [key, value]) => {
      if (shippingFormFields?.[formName] && shippingFormFields?.[formName].includes(key)) {
        return { ...item, [key]: value };
      }
      return { ...item };
    }, {}),
    [shippingFormFields]
  );
  const handleUserDetails = React.useCallback(() => {
    authToken && loadUserDetails(authToken);
  }, [loadUserDetails, authToken]);
  const shippingAddressOnCart = React.useMemo(
    () => cart?.shippingAddress ? Object.entries(cart.shippingAddress).reduce(
      (item, [key, value]) => ({ ...item, [key]: value }),
      {}
    ) : void 0,
    [cart?.shippingAddress]
  );
  React.useEffect(() => {
    if (isLoggedIn) {
      handleUserDetails();
    }
  }, [isLoggedIn]);
  const billingAddress = React.useMemo(
    () => shippingAddressOnCart ?? userData?.billingAddress ?? void 0,
    [shippingAddressOnCart, userData?.billingAddress]
  );
  return React.useMemo(
    () => ({
      areUserDetailsLoading: isLoadingUserData,
      isAddressesEqual: false,
      billingAddress: billingAddress ? formatFormFields(billingAddress, "billingAddress") : void 0,
      contactDetails: userData?.contactDetails ? formatFormFields(userData?.contactDetails, "contactDetails") : void 0,
      invoiceDetails: invoiceDetails ?? void 0,
      companyDetails,
      globalStoreId: userData?.globalStoreId,
      error: Boolean(error),
      isUserLoggedIn: isLoggedIn
    }),
    [
      isLoadingUserData,
      billingAddress,
      formatFormFields,
      userData?.contactDetails,
      userData?.globalStoreId,
      invoiceDetails,
      companyDetails,
      error,
      isLoggedIn
    ]
  );
};
export {
  useUserStateConfig
};
//# sourceMappingURL=useUserStateConfig.js.map
